/* eslint-disable @typescript-eslint/no-unused-vars */
import { getMeQuery } from "@/queries";
import { AuthProvider } from "react-admin";
import { LocalStorageService } from "../local-storage-service.util";
import { RaAction, routingPermissionsMatrix } from "../permissions.util";
import { ResourceName } from "../react-admin.util";

export type LoginResponse = {
  redirectTo: string;
  isPasswordChangeRequired: boolean;
};

export const authProvider: AuthProvider = {
  async checkError(error) {
    console.error(error);
  },
  async checkAuth() {
    const accessToken = LocalStorageService.getAccessToken();

    if (!accessToken) {
      throw new Error();
    }
  },
  async getIdentity() {
    try {
      const identity = await getMeQuery();

      return identity;
    } catch (error) {
      throw new Error(`Fetch identity error: ${error}`);
    }
  },
  async canAccess(params) {
    const { resource, action } = params as {
      resource: ResourceName;
      action: RaAction;
    };

    try {
      const { role } = await getMeQuery();

      const roleMatrix = routingPermissionsMatrix[role] ?? {};
      const permissionsMatrix = roleMatrix[resource] ?? {};

      // If explicitly denied (false), return false. Otherwise default to true.
      const isDenied = permissionsMatrix[action] === false;
      return !isDenied;
    } catch (_) {
      return false;
    }
  },
  async login() {
    return Promise.resolve();
  },
  async logout() {},
};
